export default __webpack_public_path__ + "static/media/graduate.7da61014.png";